import type { ArchiveSnapshotReviewItem, SuccessorReviewItem } from './apiClient';

export interface SuccessorReviewSummary {
  badgeLabel: string;
  detailLabel: string;
  defaultDraftValue: string;
}

export interface SnapshotReviewSummary {
  badgeLabel: string;
  detailLabel: string;
}

export function buildSuccessorReviewSummary(item: SuccessorReviewItem): SuccessorReviewSummary {
  if (item.issueType === 'orphan_successor' && item.successorOfficialId) {
    return {
      badgeLabel: 'Orphan successor link',
      detailLabel: `Currently points to ${item.successorOfficialId}. Update or clear the link before archive history drifts.`,
      defaultDraftValue: item.successorOfficialId,
    };
  }

  return {
    badgeLabel: 'Missing successor link',
    detailLabel: 'No successor is recorded for this archived official yet.',
    defaultDraftValue: '',
  };
}

export function buildSnapshotReviewSummary(item: ArchiveSnapshotReviewItem): SnapshotReviewSummary {
  return {
    badgeLabel: 'Missing frozen snapshot',
    detailLabel: item.hasSuccessorLink && item.successorOfficialId
      ? `Successor link recorded: ${item.successorOfficialId}.`
      : 'No successor link is stored on the archived record yet.',
  };
}
